import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Spacing from './Spacing';
import ClientProvider from './client';
export default createDemo(import.meta.url, Spacing, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/avatars/demos/spacing/Spacing.tsx",
    "fileName": "Spacing.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Avatar from '@mui/material/Avatar';\nimport AvatarGroup from '@mui/material/AvatarGroup';\nimport Stack from '@mui/material/Stack';\n\nexport default function Spacing() {\n  return (\n    <Stack spacing={4}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <AvatarGroup spacing=\"medium\">\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n      <AvatarGroup spacing=\"small\">\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n      <AvatarGroup spacing={24}>\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 25,
        "focusedLines": 15,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Avatar from '@mui/material/Avatar';\nimport AvatarGroup from '@mui/material/AvatarGroup';\nimport Stack from '@mui/material/Stack';\n\nexport default function Spacing() {\n  return (\n    <Stack spacing={4}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <AvatarGroup spacing=\"medium\">\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n      <AvatarGroup spacing=\"small\">\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n      <AvatarGroup spacing={24}>\n        <Avatar alt=\"Remy Sharp\" src=\"/static/images/avatar/1.jpg\" />\n        <Avatar alt=\"Travis Howard\" src=\"/static/images/avatar/2.jpg\" />\n        <Avatar alt=\"Cindy Baker\" src=\"/static/images/avatar/3.jpg\" />\n      </AvatarGroup>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "medium",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Remy Sharp",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/1.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Travis Howard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/2.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Cindy Baker",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/3.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Remy Sharp",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/1.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Travis Howard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/2.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Cindy Baker",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/3.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "24"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Remy Sharp",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/1.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Travis Howard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/2.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Cindy Baker",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "src"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/static/images/avatar/3.jpg",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "AvatarGroup"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 25,
    "focusedLines": 15,
    "collapsible": true,
    "externals": [
      "@mui/material/Avatar",
      "@mui/material/AvatarGroup",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
